import { z } from "zod"

export const LoginSchema = z.object({
    country: z.string().nullable().optional(),
    zipCode: z.string().nullable().optional(),
    birthdate: z.string().nullable().optional(),
    proDate: z.string().nullable().optional(),
    comUsername: z.string().nullable().optional(),
    companyName: z.string().nullable().optional(),
    actState: z.number().nullable().optional(),
    sendResetPasswordTime: z.string().nullable().optional(),
    province: z.string().nullable().optional(),
    daytimePhoneCC: z.string().nullable().optional(),
    autelId: z.string().nullable().optional(),
    avatar_uploadtime: z.string().nullable().optional(),
    id: z.number(),
    daytimePhone: z.string().nullable().optional(),
    mobilePhoneCC: z.string().nullable().optional(),
    facebookId: z.string().nullable().optional(),
    isAllowSendEmail: z.number().nullable().optional(),
    telephone: z.string().nullable().optional(),
    languageCode: z.string().nullable().optional(),
    freshdeskId: z.string().nullable().optional(),
    warrantyDate: z.string().nullable().optional(),
    serialNo: z.string().nullable().optional(),
    actCode: z.string(),
    firstName: z.string().nullable().optional(),
    regTime: z.string().nullable().optional(),
    mailbox: z.string().nullable().optional(),
    mobilePhone: z.string().nullable().optional(),
    sourceType: z.number().nullable().optional(),
    name: z.string().nullable().optional(),
    comName: z.string().nullable().optional(),
    proRegTime: z.string().nullable().optional(),
    sendActiveTime: z.string().nullable().optional(),
    lastName: z.string().nullable().optional(),
    code: z.string(),
    city: z.string().nullable().optional(),
    daytimePhoneExtCode: z.string().nullable().optional(),
    questionCode: z.string().nullable().optional(),
    userPwd: z.string().nullable().optional(),
    sendSecondEmailActiveTime: z.string().nullable().optional(),
    daytimePhoneAC: z.string().nullable().optional(),
    company: z.string().nullable().optional(),
    secondActState: z.number().nullable().optional(),
    mobilePhoneAC: z.string().nullable().optional(),
    address: z.string().nullable().optional(),
    expTime: z.string().nullable().optional(),
    sex: z.string().nullable().optional(),
    secondEmail: z.string().nullable().optional(),
    token: z.string(),
    warrantymonth: z.string().nullable().optional(),
    lastLoginTime: z.string().nullable().optional(),
    answer: z.string().nullable().optional(),
    avatar_url: z.string().nullable().optional(),
    middleName: z.string().nullable().optional(),
})

export type Login = z.infer<typeof LoginSchema>

const FlyRecordFileSchema = z.object({
    uniqFilename: z.string(),
    filetype: z.string(),
    oriFilename: z.string(),
    filesize: z.number(),
    filemd5: z.string(),
    uploadTime: z.string(),
})

export type FlyRecordFile = z.infer<typeof FlyRecordFileSchema>

const FlyRecordSchema = z.object({
    flyrecordId: z.string(),
    flyrecordIdCreateTime: z.string(),
    takeoffTime: z.string(),
    flyTimeDuration: z.number(),
    flyDistance: z.number(),
    flyMaxAltitude: z.number(),
    locationName: z.string(),
    autelId: z.string(),
    proSN: z.string(),
    model: z.number(),
    log_version: z.number(),
    imageCount: z.number(),
    videoCount: z.number(),
    videoTimeDuration: z.number(),
    isFavorite: z.boolean(),
    firewareInfo: z.string(),
    files: z.array(FlyRecordFileSchema),
})

export type FlyRecord = z.infer<typeof FlyRecordSchema>

const FlightRecordsDataSchema = z.object({
    itemCounts: z.number(),
    itemOffset: z.number(),
    flyreIdAmount: z.number(),
    action: z.string(),
    status: z.string(),
    flyrecordIds: z.array(FlyRecordSchema),
})

export const FlightRecordsResponseSchema = z.object({
    code: z.number(),
    data: z.union([FlightRecordsDataSchema, z.string()]).optional(),
    msg: z.string().optional(),
})

export type FlightRecordsResponse = z.infer<typeof FlightRecordsResponseSchema>

const ProductSchema = z.object({
    picPath: z.string(),
    proSerialNo: z.string(),
    proTypeName: z.string(),
    proCode: z.string(),
    deviceAlias: z.string(),
    aircraftSerialNumber: z.string(),
    proRegTime: z.string(),
})

const ProductsDataSchema = z.object({
    result: z.array(ProductSchema),
    totalCount: z.number(),
})

export type ProductsData = z.infer<typeof ProductsDataSchema>

export const ProductsResponseSchema = z.object({
    code: z.number(),
    data: z.union([ProductsDataSchema, z.string()]).optional(),
    msg: z.string().optional(),
})

export type ProductsResponse = z.infer<typeof ProductsResponseSchema>
